"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _nicbaseForms = require("nicbase-forms");

var _MonthCalendar = _interopRequireDefault(require("nicbase-rc-calendar/lib/MonthCalendar"));

var _Picker = _interopRequireDefault(require("nicbase-rc-calendar/lib/Picker"));

var _locales = _interopRequireDefault(require("../locales"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MonthPicker = function MonthPicker(_ref) {
  var timezone = _ref.timezone,
      locale = _ref.locale,
      disabled = _ref.disabled,
      inputLabel = _ref.inputLabel,
      hideLabel = _ref.hideLabel,
      onSelect = _ref.onSelect,
      initialValue = _ref.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(initialValue && _momentTimezone["default"].tz((0, _momentTimezone["default"])(initialValue), timezone)),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var onChange = function onChange(newValue) {
    setValue(newValue);
    onSelect({
      from: _momentTimezone["default"].tz(newValue, timezone).clone().startOf('month').toDate(),
      until: _momentTimezone["default"].tz(newValue, timezone).clone().endOf('month').toDate()
    });
  };

  return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
    disabled: disabled,
    onOpenChange: setOpen,
    onChange: onChange,
    open: open,
    value: value && value.locale(locale),
    calendar: /*#__PURE__*/_react["default"].createElement(_MonthCalendar["default"], {
      locale: _locales["default"][locale]
    })
  }, function (_ref2) {
    var inputValue = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      disabled: disabled,
      label: inputLabel,
      hideLabel: hideLabel,
      readOnly: true,
      value: inputValue && (0, _momentTimezone["default"])(inputValue).locale(locale).format('MMMM YYYY') || ''
    });
  }));
};

MonthPicker.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  locale: _propTypes["default"].string,
  timezone: _propTypes["default"].string,
  inputLabel: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool,
  onSelect: _propTypes["default"].func
};
MonthPicker.defaultProps = {
  value: undefined,
  disabled: false,
  locale: 'en-GB',
  timezone: 'Europe/London',
  inputLabel: '',
  hideLabel: false,
  onSelect: function onSelect() {}
};
var _default = MonthPicker;
exports["default"] = _default;